import React, { h } from 'preact'

interface Props {
    display?: string
    flexDirection?:
        | 'row'
        | 'row-reverse'
        | 'column'
        | 'column-reverse'
        | 'initial'
        | 'inherit'
    alignItems?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch'
    justifyContent?:
        | 'flex-start'
        | 'flex-end'
        | 'center'
        | 'space-between'
        | 'space-around'
        | 'space-evenly'
    padding?: string
    width?: string
    maxWidth?: string
    height?: string
    position?: 'static' | 'relative' | 'fixed' | 'absolute' | 'sticky'

    onClick?: () => void
    className?: string
}

/**
 * Convenience <Box/> definition a-la-MUI.
 *
 * @param props
 */
export const Box: React.FunctionalComponent<Props> = (props) => {
    const {
        display,
        flexDirection,
        alignItems,
        justifyContent,
        width,
        maxWidth,
        height,
        className,
        padding,
        children,
        ...rest
    } = props
    return (
        <div
            style={{
                display,
                flexDirection,
                alignItems,
                justifyContent,
                padding,
                width,
                height,
                maxWidth,
            }}
            className={className}
            {...rest}
        >
            {children}
        </div>
    )
}
